module.exports = __webpack_public_path__ + "static/media/Esforços.7b326922.png";